import { AnalyticsMarketingCardService } from './analytics';
import { EINNO_CUSTOMERTYPE, EINNO_TENANTVERSION, InnoMarketingCardService } from './inno';
export { MarketingCardService } from './base';
export { AnalyticsMarketingCardService, InnoMarketingCardService, EINNO_CUSTOMERTYPE, EINNO_TENANTVERSION };
/**
 * 变量类型, 用于bo表单遍历展示对应组件
 */
export var VAR_TYPE;
(function (VAR_TYPE) {
    VAR_TYPE["TEXT"] = "TEXT";
    VAR_TYPE["BOOLEAN"] = "BOOLEAN";
    VAR_TYPE["URL"] = "URL";
    VAR_TYPE["IMAGE"] = "IMAGE";
    VAR_TYPE["COLOR"] = "COLOR";
    VAR_TYPE["NUMBER"] = "NUMBER";
    VAR_TYPE["PERCENT"] = "PERCENT";
    VAR_TYPE["OPTION"] = "OPTION";
})(VAR_TYPE || (VAR_TYPE = {}));
export var E_LANG;
(function (E_LANG) {
    E_LANG["CN"] = "cn";
    E_LANG["EN"] = "en";
    E_LANG["JP"] = "jp";
    E_LANG["TW"] = "tw";
})(E_LANG || (E_LANG = {}));
export const AnalyticsMarketingCardFormConfig = [
    {
        key: 'title',
        type: VAR_TYPE.TEXT,
        max: 256,
    },
    {
        key: 'desc',
        type: VAR_TYPE.TEXT,
        max: 512
    },
    {
        key: 'button',
        type: VAR_TYPE.TEXT,
        max: 64,
    },
    {
        key: 'color',
        type: VAR_TYPE.COLOR,
    },
    {
        key: 'img',
        type: VAR_TYPE.IMAGE,
    },
    {
        key: 'link',
        type: VAR_TYPE.URL
    },
];
export const InnoMarketingCardFormConfig = [
    {
        key: 'tenant_version',
        label: 'Tenant Version',
        type: VAR_TYPE.OPTION,
        options: [{
                label: 'Professional',
                value: EINNO_TENANTVERSION.professional,
            }, {
                label: 'Standard',
                value: EINNO_TENANTVERSION.standard,
            }],
    },
    {
        key: 'customer_type',
        label: 'Customer Type',
        type: VAR_TYPE.OPTION,
        options: [{
                label: 'Official',
                value: EINNO_CUSTOMERTYPE.official,
            }, {
                label: 'Trial',
                value: EINNO_CUSTOMERTYPE.trial,
            }],
    },
    {
        key: 'title',
        type: VAR_TYPE.TEXT,
        max: 256,
    },
    {
        key: 'desc',
        type: VAR_TYPE.TEXT,
        max: 512
    },
    {
        key: 'button',
        type: VAR_TYPE.TEXT,
        max: 64,
    },
    {
        key: 'color',
        type: VAR_TYPE.COLOR,
    },
    {
        key: 'img',
        type: VAR_TYPE.IMAGE,
    },
    {
        key: 'link',
        type: VAR_TYPE.URL
    },
];
export var E_PRODUCT_NAME;
(function (E_PRODUCT_NAME) {
    E_PRODUCT_NAME["ANALYTICS"] = "analytics";
})(E_PRODUCT_NAME || (E_PRODUCT_NAME = {}));
/**
 * 项目组件映射，用于bo展示
 * 每个product可能存在多个模板组件,每个组件提供一个service,继承MarketingCardService
 * 每个组件提供一个service存在静态类型componentName
 */
export const ProductCardMap = {
    analytics: {
        [AnalyticsMarketingCardService.componentName]: AnalyticsMarketingCardService,
    },
    inno: {
        [InnoMarketingCardService.componentName]: InnoMarketingCardService,
    },
};
//# sourceMappingURL=index.js.map